import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import LoadingDialog from './LoadingDialog';
/**
 * Load Guard passes when following items have been loaded
 * 1) current Organization
 * 2) current Portal
 * 3) stylesheet
 * 4) customer
 *
 * @returns
 */
const PortalLoadGuard = ({ children }) => {
    const [ready, setReady] = useState(false);
    const store = useStore();
    useEffect(() => {
        if (store.status === 'ready') {
            const promises = [
                store.load('organization', store.currentOrganization.id),
                store.load('portal', store.currentPortal?.key),
                store.currentHub?.key ? store.load('hub', store.currentHub?.key) : Promise.resolve(),
            ];
            Promise.allSettled(promises)
                .then(() => setReady(true));
        }
    }, [store, store.status]);
    console.log('PortalLoadGuard', {
        portal: store.currentPortal,
        customer: store.currentCustomer,
        isAnonymous: store.isAnonymous,
    });
    if (ready) {
        return (children);
    }
    return (_jsx(LoadingDialog, {}));
};
export default observer(PortalLoadGuard);
//# sourceMappingURL=PortalLoadGuard.js.map